import { intersect, struct } from 'io-ts/Decoder';

import { FilterRequest } from '../../../../report/time-per-job';
import { Request as PaginationRequest } from '../../../generic/pagination/definite/Request';

export const Request = intersect(FilterRequest)(
	struct({
		pagination: PaginationRequest,
	})
);
